module.exports = __webpack_public_path__ + "img/06-01-01-zl-pg.3ccac0f6.jpg";